import {
    getAggregatedTiers,
    getSingleTiers,
} from "app/pages/website-analysis/traffic-sources/search/components/filters/RankingTierFilterV2";
import { EBrandedNonBrandedValues } from "app/pages/website-analysis/traffic-sources/search/components/WebsiteKeywordsPageTypes";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

export const getRankingDistributionTableTopContext = (args) => {
    const { isCompare, chosenItems, tableData, tableFilters, onFilterChange, metric } = args;
    return {
        isCompare,
        metric,
        chosenItems: chosenItems,
        tableFilters,
        tableData: tableData,

        onBrandedNonBrandedChange: (item) => {
            const params = {
                IncludeBranded: item?.id === EBrandedNonBrandedValues.IncludeBranded || false,
                IncludeNoneBranded: item?.id === EBrandedNonBrandedValues.IncludeNoneBranded || false,
            };
            proNavigator.applyUpdateParams(params);
            if (item) {
                allTrackers.dispatchTrackEvent(
                    "Filter Table",
                    "click",
                    `Filters/BrandedNonBranded/${EBrandedNonBrandedValues[item.id] || ""}`,
                );
            }
        },
        onPositionTrendChange: (postitionTrendValue: string) => {
            if (!postitionTrendValue) {
                proNavigator.applyUpdateParams({ positionTrends: null });
                return;
            }

            const currentDomains = chosenItems.map((item) => item.name);
            const trendsArray = postitionTrendValue.split(",");
            const validTrends = trendsArray.filter((trend) => {
                const [domain] = trend.split(":");
                return currentDomains.includes(domain);
            });

            const cleanedValue = validTrends.length > 0 ? validTrends.join(",") : null;
            proNavigator.applyUpdateParams({ positionTrends: cleanedValue });
        },
        onVolumeChange: (value) => {
            const { fromValue, toValue } = value;
            const params = {
                volumeFromValue: fromValue,
                volumeToValue: toValue,
            };
            proNavigator.applyUpdateParams(params);
            if (fromValue || toValue) {
                allTrackers.dispatchTrackEvent(
                    "Filter Table",
                    "switch",
                    `Filters/Volume/from:${fromValue || ""} to:${toValue || ""}`,
                );
            }
        },
        onCpcChange: (value) => {
            const { fromValue, toValue } = value;
            const params = {
                cpcFromValue: fromValue,
                cpcToValue: toValue,
            };
            proNavigator.applyUpdateParams(params);
            if (fromValue || toValue) {
                allTrackers.dispatchTrackEvent(
                    "Filter Table",
                    "switch",
                    `Filters/Cpc/from:${fromValue || ""} to:${toValue || ""}`,
                );
            }
        },
        onPhraseChange: (value) => {
            const params = {
                selectedPhrase: value,
            };
            proNavigator.applyUpdateParams(params);
            value && allTrackers.dispatchTrackEvent("Filter Table", "click", `Filters/Phrase/${value || ""}`);
        },
        onSerpFilterApply: (features) => {
            const params = {
                serp: features.join(","),
            };
            proNavigator.applyUpdateParams(params);
            onFilterChange({ serp: features });
        },
        onRankingTierChange: (rankingTier, isCompare?) => {
            let positionName, positionValue;
            if (!isCompare && rankingTier) {
                [positionName, positionValue] = rankingTier.split(":");
            }
            const params = {
                ranking: rankingTier ?? null,
            };
            proNavigator.applyUpdateParams(params);
            if (rankingTier && !isCompare) {
                const single = getSingleTiers().find((tier) => tier.value === positionValue);
                const aggregated = getAggregatedTiers().find((tier) => tier.value === positionValue);
                const trackingValue = single ? single.value : aggregated.text;
                allTrackers.dispatchTrackEvent("Filter Table", "click", `Filters/Positions/${trackingValue || ""}`);
            }
        },
        onKeywordBooleanChange: (
            includeKeywords?: string,
            includeKeywordGroups?: string,
            excludeKeywords?: string,
            excludeKeywordGroups?: string,
        ) => {
            const params = {
                IncludeTerms: includeKeywords ?? null,
                ExcludeTerms: excludeKeywords ?? null,
                IncludeKeywordGroups: includeKeywordGroups ?? null,
                ExcludeKeywordGroups: excludeKeywordGroups ?? null,
            };
            proNavigator.applyUpdateParams(params);
        },
        onUrlBooleanChange: (includeUrls?: string, excludeUrls?: string) => {
            const params = {
                IncludeUrls: includeUrls ?? null,
                ExcludeUrls: excludeUrls ?? null,
            };
            proNavigator.applyUpdateParams(params);
        },
    };
};
